import { Button, CircularProgress, Typography } from "@mui/material";
import { FC, useContext, useEffect, useState } from "react";
import CustomChipInput from "./CustomChipInput";
import { useMutation } from "react-query";
import { getMangementPlan, postManagementPlan } from "../../services";
import { useParams } from "react-router-dom";
import usePopup from "../../../hooks/usePopup";
// import LogComonent from "../layouts/LogComonent";
import { PatientManagementContext } from "./PatientManagementPlanProvider";
import { wordBreak } from ".";
import HistoryComponent from "../layouts/HistoryComponent";
import { EmrContext } from "../../index";
const ManagementPlan: FC = () => {
  const { encounterId } = useParams();
  const { showSnackbar } = usePopup();
  const { triggerConsultationStart } = useContext(EmrContext);
  const [_saved, setSaved] = useState<boolean>(false)
  const { setEditedField } = useContext(PatientManagementContext)
  const [chips, setChips] = useState<string[]>([]);
  const [initialChips, setInitialChips] = useState<string[]>([]); // store fetched values

  const {
    mutate: fetctList,
    data,
    isLoading: listLoading,
  } = useMutation(getMangementPlan, {
    onSuccess: (result) => {
      if (result.responseIndicator == "success") {
        const planArray = result.response.managementPlan
          ? result.response.managementPlan.split(wordBreak)
          : [];
        setChips(planArray);
        setInitialChips(planArray); // ✅ keep original
      }
    },
  });

  const { mutate: saveManagementPlan, data: saveData, isLoading: saveLoading } = useMutation(
    postManagementPlan,
    {
      onSuccess: (result) => {
        if (
          result.responseIndicator == "success") {
          showSnackbar({
            message: "Saved successfully !",
            open: true,
            variant: "success",
            duration: 2000,
          });
          triggerConsultationStart();
          setEditedField(null)
          setSaved(true)
          fetctList(encounterId as string);
        } else {
          showSnackbar({
            message: "Failed !",
            open: true,
            variant: "warning",
            duration: 2000,
          });
        }
      },
      onError: () => {
        showSnackbar({
          message: "Something went wrong !",
          open: true,
          variant: "warning",
          duration: 2000,
        });
      },
    }
  );
  console.log("saveManagementPlan:::", saveData)

  const handleSave = () => {
    const managementPlan = chips.join(wordBreak);

    // check if anything changed
    // const hasChanges =
    //   chips.length !== initialChips.length ||
    //   chips.some((chip, idx) => chip !== initialChips[idx]);
    console.log(initialChips.length)
    // if (!hasChanges) {
    //   showSnackbar({
    //     message: "No new items to add",
    //     open: true,
    //     variant: "warning",
    //     duration: 2000,
    //   });
    //   return;
    // }

    saveManagementPlan({
      id: data?.response.id || null,
      companyId: 0,
      encounterId: parseInt(encounterId as string),
      IP: "",
      isModified: 0,
      managementPlan,
      status: 1,
      visitId: 0,
      revertFlag: false,
    });
  };



  const handleReset = () => {
    if (chips.length > 0) {
      saveManagementPlan({
        id: data?.response.id || null,
        companyId: 0,
        encounterId: parseInt(encounterId as string),
        IP: "",
        isModified: 1,
        managementPlan: "",
        status: 1,
        visitId: 0,
        revertFlag: false
      });
    }
  };

  useEffect(() => {
    fetctList(encounterId as string);
  }, []);
  return (
    <div className="border-2 rounded">
      <div className="p-2 border-b flex justify-between items-center">
        <Typography color="primary" fontWeight={600}>
          Management Plan
        </Typography>
        <div>
          {/* <LogComonent  /> */}
          <HistoryComponent logProps={{field:"managementplan", title:"Management plan"}} title="Management Plan" tableprops={tableprops} />
        </div>
      </div>
      <div className="p-2  grid grid-cols-12 gap-x-6 gap-y-2">
        <div className="col-span-9">
          <CustomChipInput
            placeholder="Managment plan"
            chips={chips}
            setChips={(newChips) => {
              setChips(newChips);
              setEditedField("managementPlan");
            }}
            loading={listLoading}
            component={"managementPlan"}
          />
        </div>
        <div className="col-span-2 flex gap-2 items-center">
          <Button
            color="success"
            onClick={handleSave}
            disabled={saveLoading}
            endIcon={saveLoading && <CircularProgress size={18} />}
          >
            save
          </Button>
          <Button color="error" disabled={saveLoading} onClick={handleReset}>
            reset
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ManagementPlan;
// const headings = ["DATE", "CLINICAL IMPRESSION", "DONE BY"];
const tableprops = [
  {
    heading: "Date", key: "createdByDate",date:"DD-MM-YYYY hh:mm A"
  },
  {
    heading: "Management Plan", key: "managementPlan"
  }
]
